import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const StoreName = ({ status, storeName }) => {
  if (!storeName) return null

  return (
    <Styles.StoreNameContainer status={status}>
      <span>|</span>
      <Text type="bodyMBold">{storeName}</Text>
    </Styles.StoreNameContainer>
  )
}

export default StoreName
